import { apiGet } from '@/services/apiClient';
import type { EventArpLogRow, EventLogRow } from '../types';

/**
 * `EventODataController` is declared with `[Route("api/[controller]")]`, so
 * the gateway-stripped path is `/api/EventOData/...`. `VITE_API_BASE_URL`
 * provides the host + the gateway prefix.
 */
const CONTROLLER = 'api/EventOData';

/**
 * Mirrors `EventModel.GetAllEvents` in the Blazor app:
 *   GET <base>/api/EventOData/GetEventsBySearch
 *       ?eventcode=&startDate=&endDate=&searchEvents=
 *
 * Blazor defaults the date range to today ± 10 days; callers should pass
 * the same values to preserve parity.
 */
export async function fetchEventLog(params: {
  eventCode?: string;
  startDate: Date;
  endDate: Date;
  searchEvents?: string;
}): Promise<EventLogRow[]> {
  const qs = new URLSearchParams({
    eventcode: params.eventCode ?? '',
    startDate: params.startDate.toISOString(),
    endDate: params.endDate.toISOString(),
    searchEvents: params.searchEvents ?? '',
  });
  return apiGet<EventLogRow[]>(`${CONTROLLER}/GetEventsBySearch?${qs}`);
}

/**
 * Mirrors `EventModel.GetARPEvents`:
 *   GET <base>/api/EventOData/GetEventsARPSignalLog?eventcode=
 */
export async function fetchEventArpLog(eventCode: string): Promise<EventArpLogRow[]> {
  const qs = new URLSearchParams({ eventcode: eventCode });
  return apiGet<EventArpLogRow[]>(`${CONTROLLER}/GetEventsARPSignalLog?${qs}`);
}
